import React, { useState } from 'react';
import OrangeButton from '../buttons/orange-button';
import HeroContainer from '../ui/hero-container';
import AnimatedText from '../ui/animation/AnimatedText';
import CustomModal from '../CustomModal';
import SignUpPopup from '../../Pages/tutor-details/components/SignupPopup';

export function HeroSection() {
  const [showSignupModal, setShowSignupModal] = useState(false);

  return (
    <HeroContainer className="hero-section !pt-8">
      <div className="container mx-auto !pt-2 text-center">
        <div className="mb-6 inline-flex  h-10 items-center gap-2 rounded-full px-4 py-2 text-white">
          <AnimatedText />
        </div>
        <h1 className="hero-title fredokaOne relative mb-6 !font-normal">
        AI-Powered Tutor Assistant<br />Your Personal Chief of Staff
          <div className="absolute left-28 top-4 hidden transform text-[40px] leading-normal tracking-[-1.12px] text-[#FFF] lg:flex">
            <img src="/images/home/home-heart.png" className="h-14 w-14" alt="home-heart" />
          </div>
          <div className="absolute left-0 top-28 hidden transform text-[40px] leading-normal tracking-[-1.12px] text-[#FFF] lg:flex">
            <img src="/images/home/home-book.png" className="h-14 w-14" alt="home-heart" />
          </div>
          <div className="absolute left-40 top-48 hidden transform text-[40px] leading-normal tracking-[-1.12px] text-[#FFF] lg:flex">
            <img src="/images/home/home-grad.png" className="h-14 w-14" alt="home-grad" />
          </div>
          <div className="absolute right-28 top-4 hidden  transform text-[40px] leading-normal tracking-[-1.12px] text-[#FFF] lg:flex">
            <img src="/images/home/home-love.png" className="h-14 w-14" alt="home-love" />
          </div>
          <div className="absolute right-4 top-36 hidden transform text-[40px] leading-normal tracking-[-1.12px] text-[#FFF] lg:flex">
            <img src="/images/home/home-openbook.png" className="h-14 w-14" alt="home-openbook" />
          </div>
          <div className="absolute right-40 top-48 hidden transform text-[40px] leading-normal tracking-[-1.12px] text-[#FFF] lg:flex">
            <img src="/images/home/home-smile.png" className="h-14 w-16" alt="home-smile" />
          </div>
        </h1>
        <p className="fredoka mx-auto max-w-[660px] text-center text-[19px] font-medium leading-[32px] tracking-[-0.22px] text-[#678285] md:text-[22px]">
        We handle your session prep, student tracking, and reporting. You focus on tutoring.
        </p>

        {/* CTA Button */}
        <div className="relative !mt-6">
          <div className="mx-auto w-full md:w-fit">
            <OrangeButton onClick={() => setShowSignupModal(true)} label={'Get Started'} />
          </div>
          {/* <img
            className="arrow-images absolute inset-0 top-28 m-auto md:right-72 md:top-28"
            alt="nocreditcard"
            src="/images/home/no-credit-card.png"
          /> */}
        </div>
      </div>
      <div className="hero-images mt-20 px-6 pb-6 md:-mt-28">
        <img src="/images/home/home-hero.png" alt="hero-img" className="hidden md:block" />
        <img src="/images/home/hero-lady.png" alt="hero-img" className="block md:mt-0 md:hidden" />
      </div>
      <CustomModal
        className="max-w-[480px]"
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      >
        <SignUpPopup />
      </CustomModal>
    </HeroContainer>
  );
}

export default HeroSection;
